<template>
  <div class="pointer-events-none absolute inset-0 hidden overflow-hidden lg:block" aria-hidden="true">
    <div
      v-for="(tile, i) in tiles"
      :key="i"
      class="absolute grid place-items-center rounded-[22px] text-primary"
      :class="tile.pos"
      :style="{
        width: `${tile.size}px`,
        height: `${tile.size}px`,
        fontSize: `${tile.size * 0.44}px`,
        transform: `rotate(${tile.rot}deg)`,
        background: 'linear-gradient(150deg, #ffffff 0%, color-mix(in srgb, var(--primary) 12%, #ffffff) 100%)',
        border: '1px solid color-mix(in srgb, var(--primary) 18%, transparent)',
        boxShadow: '0 22px 40px -14px color-mix(in srgb, var(--primary) 45%, transparent), 0 4px 10px -4px rgba(20,21,43,0.15), inset 0 2px 2px rgba(255,255,255,0.9), inset 0 -6px 10px -4px color-mix(in srgb, var(--primary) 22%, transparent)',
        animation: `pj-float ${5 + i * 0.6}s ease-in-out ${tile.delay}s infinite`,
      }"
    >
      <span style="filter: drop-shadow(0 2px 1px rgba(20,21,43,0.18))">{{ tile.g }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
const tiles = [
  { g: '✦', pos: 'top-[12%] right-[3%]', rot: -8, size: 76, delay: 0 },
  { g: '◈', pos: 'top-[44%] right-[7%]', rot: 10, size: 60, delay: 1.1 },
  { g: '❖', pos: 'bottom-[15%] right-[4%]', rot: -6, size: 68, delay: 0.6 },
  { g: '◉', pos: 'top-[15%] left-[3%]', rot: 9, size: 70, delay: 0.3 },
  { g: '▣', pos: 'top-[45%] left-[6%]', rot: -11, size: 58, delay: 1.4 },
  { g: '◐', pos: 'bottom-[17%] left-[4%]', rot: 7, size: 66, delay: 0.9 },
]
</script>
